import { emptyValidationResponse } from '../urlValidationUtils'

const FigmaValidator = (url: string) => {
  let regexGroups

  // First attempt
  regexGroups =
    /(?:https(?::|(?:%3A))(?:\/|(?:%2F))(?:\/|(?:%2F)))?(?:www.)?([\w\-_]+).com(?:\/|(?:%2F))file(?:\/|(?:%2F))([^ "\n]+)/.exec(
      url,
    )
  if (regexGroups?.[0])
    return {
      validUrl: `https://www.figma.com/embed?embed_host=share&url=https://www.figma.com/file/${regexGroups[2]}`,
      isEmbeddable: true,
    }

  return emptyValidationResponse
}

export default FigmaValidator
